import { render, staticRenderFns } from "./ComposerSessionIndicator.vue?vue&type=template&id=912fb7a2&scoped=true"
import script from "./ComposerSessionIndicator.vue?vue&type=script&lang=js"
export * from "./ComposerSessionIndicator.vue?vue&type=script&lang=js"
import style0 from "./ComposerSessionIndicator.vue?vue&type=style&index=0&id=912fb7a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912fb7a2",
  null
  
)

export default component.exports